import React from 'react';
import CommonInput from '../../components/Dashboard-res/CommonComponent/CommonInput';
import { Field, useFormikContext } from 'formik';
import { validate as validatePhoneNumber } from '../../components/PhoneNumberValidation/PhoneNumberValidation';

const Reference = () => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur
  } = useFormikContext();
  const inputLength1 = values.ref_1_number.length;
  const inputLength2 = values.ref_2_number.length;
  return (
    <div className="w-full pb-20">
      <div className="w-full bg-white px-16 md:px-3 text-center mx-auto  mt-10">
        <h2 className="text-md text-black font-roboto border-black">
          Please Provide 2 References for FCU checks
        </h2>
        <div className="mt-10 w-full block md:flex">
          <div className="w-full md:w-6/12   md:px-4">
            <div className="text-center">
              <h1 className="text-sm text-grey-350 font-roboto font-medium">
                REFERENCE-1
              </h1>
            </div>
            <div className="text-left w-full">
              <div className="mt-10">
                <CommonInput
                  name="ref_1_name"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.ref_1_name}
                  stylesContainer={{
                    height: '52px',
                    maxWidth: '100%'
                  }}
                  legendName="Name"
                  error={touched.ref_1_name && errors.ref_1_name}
                  errorMsg={errors.ref_1_name}
                  touched={touched.ref_1_name}
                />
              </div>
              <div className="mt-10">
                <div className="grid_input_container relative mb-4">
                  <div
                    style={{ marginTop: '17px' }}
                    className="absolute text-grey-50 z-10 font-normal text-sm pt-px text-md ml-4"
                  >
                    +91
                  </div>
                  <div>
                    <CommonInput
                      name="ref_1_number"
                      id="ref_1_number"
                      maxLength={10}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.ref_1_number}
                      stylesContainer={{
                        height: '52px',
                        maxWidth: '100%'
                      }}
                      inputStyle={{
                        paddingLeft: '45px',
                        letterSpacing: '1px'
                      }}
                      onBlurStyle={{
                        paddingLeft: '20px'
                      }}
                      legendStyle={{
                        paddingLeft: errors.mobile ? '20px' : '20px'
                      }}
                      legendName="Mobile Number"
                      error={touched.ref_1_number && errors.ref_1_number}
                      //errorMsg={errors.mobile}
                      className={`pt-24`}
                      touched={touched.ref_1_number}
                      errorMsg={errors.ref_1_number}
                      onKeyPress={e => {
                        validatePhoneNumber(e, inputLength1);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="mt-10">
                <CommonInput
                  name="ref_1_company"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.ref_1_company}
                  stylesContainer={{
                    height: '52px',
                    maxWidth: '100%'
                  }}
                  legendName="Company"
                  error={touched.ref_1_company && errors.ref_1_company}
                  errorMsg={errors.ref_1_company}
                  touched={touched.ref_1_company}
                />
              </div>
              <div className="mt-10">
                <CommonInput
                  name="ref_1_designation"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.ref_1_designation}
                  stylesContainer={{
                    height: '52px',
                    maxWidth: '100%'
                  }}
                  legendName="Designation"
                  error={touched.ref_1_designation && errors.ref_1_designation}
                  errorMsg={errors.ref_1_designation}
                  touched={touched.ref_1_designation}
                />
              </div>
            </div>
          </div>
          <div className="w-full md:w-6/12 md:px-4 mt-5 md:mt-0">
            <div className="text-center">
              <h1 className="text-sm text-grey-350 font-roboto font-medium">
                REFERENCE-2
              </h1>
            </div>
            <div className="text-left w-full ">
              <div className="mt-10">
                <CommonInput
                  name="ref_2_name"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.ref_2_name}
                  stylesContainer={{
                    height: '52px',
                    maxWidth: '100%'
                  }}
                  legendName="Name"
                  error={touched.ref_2_name && errors.ref_2_name}
                  errorMsg={errors.ref_2_name}
                  touched={touched.ref_2_name}
                />
              </div>
              <div className="mt-10">
                <div className="grid_input_container relative mb-4">
                  <div
                    style={{ marginTop: '17px' }}
                    className="absolute text-grey-50 z-10 font-normal text-sm pt-px text-md ml-4"
                  >
                    +91
                  </div>
                  <div>
                    <CommonInput
                      name="ref_2_number"
                      id="ref_2_number"
                      maxLength={10}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.ref_2_number}
                      stylesContainer={{
                        height: '52px',
                        maxWidth: '100%'
                      }}
                      inputStyle={{
                        paddingLeft: '45px',
                        letterSpacing: '1px'
                      }}
                      onBlurStyle={{
                        paddingLeft: '20px'
                      }}
                      legendStyle={{
                        paddingLeft: errors.mobile ? '20px' : '20px'
                      }}
                      legendName="Mobile Number"
                      error={touched.ref_2_number && errors.ref_2_number}
                      //errorMsg={errors.mobile}
                      className={`pt-24`}
                      touched={touched.ref_2_number}
                      errorMsg={errors.ref_2_number}
                      onKeyPress={e => {
                        validatePhoneNumber(e, inputLength2);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="mt-10">
                <CommonInput
                  name="ref_2_company"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.ref_2_company}
                  stylesContainer={{
                    height: '52px',
                    maxWidth: '100%'
                  }}
                  legendName="Company"
                  error={touched.ref_2_company && errors.ref_2_company}
                  errorMsg={errors.ref_2_company}
                  touched={touched.ref_2_company}
                />
              </div>
              <div className="mt-10">
                <CommonInput
                  name="ref_2_designation"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.ref_2_designation}
                  stylesContainer={{
                    height: '52px',
                    maxWidth: '100%'
                  }}
                  legendName="Designation"
                  error={touched.ref_2_designation && errors.ref_2_designation}
                  errorMsg={errors.ref_2_designation}
                  touched={touched.ref_2_designation}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-16">
        <button
          className=" submitButton w-56 block  lg:w-80  "
          type="submit"
          id="submit"
          disabled={
            errors.ref_1_name ||
            errors.ref_1_number ||
            errors.ref_1_designation ||
            errors.ref_1_company ||
            values.ref_1_name == '' ||
            values.ref_1_number == '' ||
            values.ref_1_designation == '' ||
            values.ref_1_company == '' ||
            errors.ref_2_name ||
            errors.ref_2_number ||
            errors.ref_2_designation ||
            errors.ref_2_company ||
            values.ref_2_name == '' ||
            values.ref_2_number == '' ||
            values.ref_2_designation == '' ||
            values.ref_2_company == ''
          }
        >
          CONTINUE
        </button>
      </div>
    </div>
  );
};
export default Reference;
